<template>
	<div>
		<div class="conmtont">
			<div class="flex align-center justify-between padding-sm bg-white margin-tb">
				<el-breadcrumb separator-class="el-icon-minus">
				  <el-breadcrumb-item :to="{ path: '/' }"><span class="text-sm text-666">首页</span></el-breadcrumb-item>
				  <el-breadcrumb-item :to="{ path: 'resume' }"><span class="text-sm text-666">工人简历</span></el-breadcrumb-item>
				  <el-breadcrumb-item><span class="text-sm text-666">详情</span></el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="flex">
				<div class="flex-sub">
					<div class="bg-white padding-sm radius">
						<div class="text-32 text-000 text-bold text-left" v-if="userInfo">{{userInfo.title}}</div>
						<div class="flex justify-between align-center margin-top-sm">
							<div class="">
								<div class="flex align-center justify-between">
									<p class="flex align-center" v-if="user">
										<img :src="user.avatar" class="block-30">
										<span class="text-sm text-333 margin-left-xs">{{user.nick_name}}</span>
									</p>
									<p v-if="userInfo">
										<span class="text-sm text-999 margin-left-xs">期望</span>
										<span :class="userInfo.wages == 0?'':'text-price'" class="text-prices text-bold">{{userInfo.wages == 0 ? '面议' : userInfo.wages}}</span>
									</p>
								</div>
								<div class="flex align-center justify-between margin-top-xs" v-if="userInfo">
									<div class="text-999 text-sm flex align-center">期望区域：
										<p v-for="(ele,indaex) in userInfo.area.split(',')" :key="indaex">
											<span>{{ele}}</span>
											<span v-if="indaex<userInfo.area.split(',').length-1" class="margin-lr-xs">|</span>
										</p>
									</div>
								</div>
							</div>
							<div class="flex align-center">
								<div class="colt flex align-center justify-center pointer" @click="chosecoll">
									<i class="el-icon-star-off text-theme"></i>
									<p class="margin-left-xs text-666">{{coll?'已收藏':'收藏'}}</p>
								</div>
								<div class="callbtns flex align-center justify-center margin-left-xs pointer" @click="callphone">
									<img class="call-icon" src="../../assets/img/call-icon.png" >
									<p class="text-white margin-left-xs">电话联系</p>
								</div>
							</div>
						</div>
					</div>
					<div class="bg-white margin-top padding-sm radius">
						<p class="title text-left padding-left-sm">求职详情</p>
						<div class="flex align-center margin-top-xs">
							<p class="tip text-sm text-666 margin-right-xs" v-if="userInfo">{{userInfo.experience}}年工龄</p>
							<p class="tip text-sm text-666 margin-right-xs" v-if="user&&user.nation">{{user.nation}}族</p>
							<p class="tip text-sm text-666 margin-right-xs"v-if="userInfo">{{userInfo.type | filterType}}</p>
						</div>
					</div>
					<div class="bg-white margin-top padding-sm radius"v-if="userInfo">
						<p class="title text-left padding-left-sm">自我评价</p>
						<p class="text-666 text-sm margin-top-sm text-left">{{userInfo.evaluate}}</p>
					</div>
					<div class="bg-white margin-top padding-sm radius"v-if="userInfo">
						<p class="title text-left padding-left-sm">风采展示</p>
						<p class="flex align-center margin-top-sm">
							<img class="block-143 margin-right-sm" :src="item" v-for="(item,index) in userInfo.images">
						</p>
					</div>
					<div class="bg-white margin-top padding-sm radius">
						<p class="title text-left padding-left-sm">项目经历</p>
						<div class="text-left" v-for="(item,index) in experience" :key="index">
							<p class="text-df text-333 text-bold padding-tb-xs margin-top-xs solid-bottom">{{item.work_name}}</p>
							<p class="text-sm text-666 margin-top-sm">{{item.work_content}}</p>
							<p class="margin-top-sm">
								<img class="block-143 margin-right-sm" :src="ele" v-for="(ele,indesx) in item.images" :key="indesx">
							</p>
							<p class="text-ccc text-xs margin-top">{{item.end_time}} 完工     {{item.area}}</p>
						</div>
					</div>
					<div class="bg-white margin-top padding-sm radius">
						<p class="title text-left padding-left-sm">技能证书</p>
						<div class="margin-top-sm">
							<div class="flex align-center justify-between certificate" v-for="(item,index) in certificate" :key="index">
								<p>
									<span class="text-sm text-666">名称</span>
									<span class="text-sm text-theme">{{item.certificate_name}}</span>
								</p>
								<p>
									<span class="text-sm text-666">领证时间</span>
									<span class="text-sm text-theme">{{item.time}}</span>
								</p>
							</div>
						</div>
					</div>
				</div>
				<div class="margin-left">
					<div class="flex align-center justify-between margin-bottom-sm">
						<p class="title padding-left-sm ">最新招工</p>
					</div>
					<div v-for="(item,indx) in userList" :key="indx">
						<ResumeList :data="item" :width="387" :height="168" :size="18"></ResumeList>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	import Top from '@/components/public/top.vue';
	import ResumeList from '@/components/list/resume-list.vue';
	export default {
		components: {
			Top,
			ResumeList
		},
		name: '',
		data() {
			return {
				id:0,//
				topList: [],
				banners: [],
				userInfo:null,//基础信息
				user:null,//用户信息
				experience:[],//项目经历
				certificate:[],//证书
				coll:0,//1收藏0未收藏
				isbuy: false, //是否花积分购买
			}
		},
		created() {
			//通知听不状态栏 选中的页面
			Bus.$emit('chosename','resume')
			this.id = this.$route.query.id
			this.getdetail()
			this.getUserList()
			this.getisbuyjifen()
		},
		methods: {
			back(){
				this.$router.back()
			},
			//判断是否花费积分购买
			getisbuyjifen() {
				this.ajax('get', '/api/integral/is_buy', {
					work_id: this.id,
					work_type: 2
				}, res => {
					if (res.status == 200) {
						if (res.data.code == 202) {
							this.isbuy = false
						}
						if (res.data.code == 200) {
							this.isbuy = true
						}
					}
				})
			},
			callphone() {
				if (this.isbuy) {
					let phone_num = this.user&&this.user.phone
					this.$alert('联系电话为：' + phone_num, '提示', {
						confirmButtonText: '确定',
						callback: action => {
								
						}
					});
				} else {
					this.$confirm('需要积分兑换即可查看完整电话', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
					 type: 'warning'
					}).then(() => {
						this.getbuy()
					}).catch(() => {
				
					});
				}
			},
			//花费积分购买
			getbuy() {
				let that = this
				that.ajax('post', '/api/integral/buy', {
					work_id: that.id,
					work_type: 2
				}, res => {
					if (res.status == 200) {
						if (res.data.code == 200) {
							that.$message("兑换成功")
							// this.$message.info('兑换成功');
							that.getisbuyjifen()
							let phone_num = that.user&&that.user.phone
							that.$alert('联系电话为：' + phone_num, '提示', {
								confirmButtonText: '确定',
								callback: action => {
							
								}
							});
						}
					}
				})
			},
			//收藏取消收藏
			chosecoll(){
				this.ajax('post', '/api/collection/add', {
					type_id:this.id,
					type:1
				}, res => {
					if(res.status == 200){
						this.coll = !this.coll
						this.getdetail()
					} else {
					  this.careful = ''
					}
				})
				
			},
			/**
			 * 获取招工人列表
			 * */
			getUserList(){
				this.ajax('get', '/api/pc/userInfo/getList', {
					area:'北京',
					page:1,
					sort:1,
					stat:3,
					type:'',
				}, res => {
					if(res.status == 200){
						console.log('getUserList',res);
						this.userList = res.data.data
					}
				})
			},
			/**
			 * 详情
			 * */
			getdetail(){
				this.ajax('get', '/api/pc/userInfo/getWorkerInfo', {
					id:this.id,
				}, res => {
					if(res.status == 200){
						this.userInfo = res.data.userInfo
						this.user = res.data.user
						this.coll = res.data.user&&res.data.user.coll
						this.experience = res.data.experience
						this.certificate = res.data.certificate
					}
				})
			},
		},
		filters:{
			filterType(val) {
			  switch (val) {
				case 0:
				  	return '个人';
			  	case 1:
			  		return '班组';
			  	case 2:
			  		return '施工队';
			  	case 3:
			  		return '突击队';
			  
			  	default:
			  		return '';
			  }
			}
		}
	}
</script>

<style scoped lang="less">
	.text-32{
		font-size: 32px;
	}
	.detail{
		width: 782px;
	}
	.title{
		position: relative;
		font-size: 22px;
		&:before{
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 6px;
			height: 26px;
			background: #09827B;
			content: '';
			
		}
	}
	.block-30{
		width: 30px;
		height: 30px;
		border-radius: 50%;
	}
	.colt{
		width: 111px;
		height: 45px;
		background: #FFFFFF;
		border: 1px solid #E6E6E6;
		border-radius: 23px;
	}
	.tip{
		padding: 12px 28px;
		background: #FFFFFF;
		box-shadow: 0px 5px 29px 2px rgba(204,204,204,0.3000);
		border-radius: 20px;
	}
	.callbtns{
		width: 193px;
		height: 45px;
		background: #0B837C;
		border-radius: 23px;
		.call-icon{
			width: 19px;
			height: 19px;
		}
	}
	.block-143{
		width: 143px;
		height: 143px;
	}
	.certificate{
		background: rgba(54,144,139,0.0600);
		border: 1px solid #DADADA;
		border-radius: 10px;
		padding: 15px 20px;
	}
</style>



// WEBPACK FOOTER //
// src/view/index/resume-detail.vue